import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import withRouter from "../Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import RestaurantSidebarContent from "./RestaurantSidebarContent";

const RestaurantSidebar = (props) => {
  useEffect(() => {
    const body = document.body;
    const windowSize = document.documentElement.clientWidth;

    if (props.leftMenu) {
      body.classList.add("sidebar-enable");
      if (windowSize <= 991) {
        body.classList.add("vertical-collpsed");
      }
    } else {
      body.classList.remove("sidebar-enable");
      body.classList.remove("vertical-collpsed");
    }
  }, [props.leftMenu]);

  function tToggle() {
    var body = document.body;
    var windowSize = document.documentElement.clientWidth;

    body.classList.toggle("vertical-collpsed");
    body.classList.toggle("sidebar-enable");

    if (windowSize > 991) {
      body.getAttribute("data-sidebar-size") === "sm"
        ? body.setAttribute("data-sidebar-size", "lg")
        : body.setAttribute("data-sidebar-size", "sm");
    }
  }

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <button
          onClick={() => {
            tToggle();
          }}
          type="button"
          className="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
        >
          <i className="fa fa-fw fa-bars"></i>
        </button>
        <div className="sidebar-menu-scroll">
          {props.type !== "condensed" ? <RestaurantSidebarContent /> : <RestaurantSidebarContent />}
        </div>
      </div>
    </React.Fragment>
  );
};

RestaurantSidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
    leftMenu: state.Layout.leftMenu,
  };
};
export default connect(
  mapStatetoProps,
  {},
)(withRouter(withTranslation()(RestaurantSidebar)));
